import { registerCustomDetailComponent } from '@vendure/admin-ui/core';
import { CustomerDetailPatcherComponent } from './customer-detail-patcher.component';

export default [
    registerCustomDetailComponent({
        locationId: 'customer-detail',
        component: CustomerDetailPatcherComponent,
    }),
];
